import { isFeatureEnabled } from 'owa-feature-flags';

export default function isProjectionFlightEnabled() {
    return (
        isFeatureEnabled('mail-popout-projection') ||
        isFeatureEnabled('cal-cmp-popout-projection') ||
        isFeatureEnabled('cal-fullcompose-popout-projection') ||
        isFeatureEnabled('cal-readingpane-popout-projection') ||
        isFeatureEnabled('cal-forms-popout-projection')
    );
}
